// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IpuHJ","index":"styles_index__cjeGD"};